import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

// The mobile navbar Layout renders above this screen.
const NAVBAR_HEIGHT = 64;

export const StyledEducatorsMobileWeb = styled('div')`
  /* The app sets no global box-sizing, so every padded box here states it. */
  &,
  & * {
    box-sizing: border-box;
  }

  /* Filling the viewport is what pushes the download banner to the bottom the
     way the design shows it, however short the content above turns out. */
  min-height: calc(100vh - ${NAVBAR_HEIGHT}px);
  min-height: calc(100dvh - ${NAVBAR_HEIGHT}px);
  padding: 24px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  .educators-banner {
    display: block;
    width: 100%;
    height: 112px;
    border-radius: 11.2px;
    object-fit: cover;
  }

  .educators-overview {
    flex: 1 0 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }

  /* The asset already bakes its shadow in, and its 160x112 box is the artwork
     (148.13x100, matching the design) plus 3px of bleed above and 9px below.
     The negative margins take that bleed out of the flow so the box still
     occupies the 100px the design lays out for it. */
  .educators-illustration {
    display: block;
    width: 160px;
    height: 112px;
    flex-shrink: 0;
    margin: -3px 0 -9px;
  }

  .educators-details {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  /* The copy carries the design's three line breaks as newlines, so honour
     them literally. */
  .educators-description {
    width: 100%;
    white-space: pre-line;
  }

  /* Narrower than the 375px the design was drawn at, the fixed breaks no
     longer fit — the longest line is 299px (en) and needs a 331px viewport.
     Below that the text picks its own breaks, balanced so no word is left
     alone on a line. */
  @media only screen and (max-width: 359px) {
    .educators-description {
      white-space: normal;
      text-wrap: balance;
    }
  }

  .educators-features {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .educators-feature {
    height: 32px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    border-radius: 8px;

    .MuiSvgIcon-root {
      font-size: 16px;
      flex-shrink: 0;
      color: ${COLOR.indigo[80]};
    }

    .MuiTypography-root {
      letter-spacing: 0;
    }
  }

  /* Stays in view while the page scrolls and settles into its own place at the
     end. The offset matches the page padding, so nothing shifts when it lands.
     Layout's main panel is the scroll container this sticks to. */
  .educators-app-cta {
    position: sticky;
    bottom: 16px;
    z-index: 1;
    width: 100%;
    height: 68px;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 24px;
    background: ${COLOR.yellow.default};
    border: 0.5px solid ${COLOR.indigo[16]};
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    overflow: clip;
  }

  /* The icon and the two lines of text travel together, 8px apart; the card's
     own 24px gap sits between that group and the button. */
  .educators-app-group {
    flex: 1 0 0;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .educators-app-icon {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${COLOR.white};
    border-radius: 12px;

    img {
      display: block;
      width: 37.5px;
      height: 17.67px;
    }
  }

  /* Ellipsis rather than wrapping: the design keeps both lines on one row, and
     the name still has to survive a 320px screen. */
  .educators-app-info {
    flex: 1 0 0;
    min-width: 0;
    display: flex;
    flex-direction: column;

    .MuiTypography-root {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .educators-app-name {
    letter-spacing: 0;
  }

  /* No 10px variant exists in Typography, so this is the one size stated here. */
  .educators-app-subtitle {
    font-size: 10px;
    line-height: 16px;
  }
`;
